export const GTMHelper = {
    push: (event: any) => {
        (window as any).dataLayer?.push(event)
    }
}